import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'

import 'element-plus/dist/index.css'

import App from './App.vue'
import message from './message.json'
import { store } from './store'
import { ConfigStateModuleName } from './store/modules/modules'

const language = ((window.navigator.languages && window.navigator.languages[0]) || window.navigator.language).slice(
  0,
  2
)

const i18n = createI18n({
  locale: store.getters[`${ConfigStateModuleName}/displayLanguage`] === 'Japanese' ? 'ja' : 'en',
  messages: message
})

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store)
app.use(i18n)
app.use(ElementPlus)

app.mount('#app')

store.watch(
  () => store.getters[`${ConfigStateModuleName}/displayLanguage`],
  newValue => {
    i18n.global.locale = newValue === 'Japanese' ? 'ja' : 'en'
  }
)
